import { Type } from 'class-transformer';
import { OrganizationModel } from '../../organizations/models/organization.model';
import { UserAccountSetting } from './account-settings.model';
import { ProfressionalSubscriptionModel } from './subscription/professional-subscription.model';
import { UserSubscriptionModel } from './subscription/user-subscription.model';

interface AccountVerificationModel {
  verification_jwt: string;
  verification_required: boolean;
}

export class UserProfileModel {
  city: string;
  first_name: string;
  last_name: string;
  institution: string;
  grade_level: string;
  country: string;
  sort_name_by_last: string;
  email: string;
  state: string;
  sort_email: string;
  eid: string;
  registration_date: string;

  // user account settings
  account_settings: UserAccountSetting[];

  // account verification
  account_verification: AccountVerificationModel;

  @Type(() => OrganizationModel)
  organizations: OrganizationModel[];

  is_third_party: boolean;
  user_is_developer: boolean;
  id: number;
  third_party_provider_name: string;

  // subscription info
  subscription?: UserSubscriptionModel | ProfressionalSubscriptionModel;
  premium_account_type: 'group' | 'individual';
  premium_account: boolean;
  premium_account_valid: boolean;

  // developer info
  developer_account: boolean;
  developer_account_active: boolean;
  developer_account_verified: boolean;
  developer_account_valid_plan: boolean;

  // When the user has a developer account and where developer_account_active, developer_account_valid_plan, and
  // developer_account_verified are all true, the parameter developer_portal_signin_url will be returned with custom
  // credentials that will automatically sign the user into their developer account.
  developer_portal_signin_url: string;
}

export function isBiodigitalProfile(profile: UserProfileModel) {
  return profile.email.endsWith('@biodigital.com');
}
